
import { defineComponent } from "vue";
import Intro from "@/components/Intro.vue";
import Summary from "@/components/Summary.vue";
import Experience from "@/components/Experience.vue";
import Education from "@/components/Education.vue";
import Certificates from "@/components/Certificates.vue";
import KeySkills from "@/components/KeySkills.vue";
import SideProjects from "./components/SideProjects.vue";

export default defineComponent({
  components: {
    Intro,
    Summary,
    Experience,
    Education,
    Certificates,
    KeySkills,
    SideProjects
  }
});
